import React from 'react'
import QuizManagement from './QuizGrid';

export default function Quiz() {
  return (
    <div>
      <QuizManagement />
    </div>
  );
}
